// Generated by ts-to-zod
import { z } from "zod";

export const organizationHomeImageResDtoSchema = z.object({
  enabled: z.boolean(),
  contentType: z.record(z.any()).nullable(),
  data: z.string().nullable(),
  title: z.string().nullable(),
  subtitle: z.string().nullable(),
});

export const currentOrganizationResDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  isActive: z.boolean(),
  replyToEmail: z.string().nullable(),
  homeImage: organizationHomeImageResDtoSchema.optional(),
});

export const adminPatchCurrentOrganizationReqDtoSchema = z.object({
  replyToEmail: z.string().nullable(),
});

export const adminOrganizationHomeImageResDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string(),
  zipCode: z.string().nullable(),
  replyToEmail: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  homeImage: organizationHomeImageResDtoSchema.optional(),
});

export const adminOrganizationResDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string(),
  zipCode: z.string().nullable(),
  replyToEmail: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const adminOrganizationStatsResDtoSchema = z.object({
  adminCount: z.number(),
  customerCount: z.number(),
  driverCount: z.number(),
  regionCount: z.number(),
  vehicleCount: z.number(),
  locationCount: z.number(),
});

export const adminOrganizationDetailResDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string(),
  zipCode: z.string().nullable(),
  replyToEmail: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  homeImage: organizationHomeImageResDtoSchema.optional(),
  stats: adminOrganizationStatsResDtoSchema,
});

export const adminPatchOrganizationStatusReqDtoSchema = z.object({
  isActive: z.boolean(),
});

export const adminCustomerLeadResDtoSchema = z.object({
  id: z.string(),
});

export const adminCustomerResDtoSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  phone: z.string(),
  emailConfirmed: z.boolean(),
  invited: z.string(),
  serviceAccess: z.boolean(),
  createdAt: z.string().datetime(),
  lead: adminCustomerLeadResDtoSchema.optional(),
});

export const adminRegionSuggestedDriversResDtoSchema = z.object({
  driverId: z.string(),
  name: z.string(),
  email: z.string(),
  mode: z.literal("DAILY_SHIFT"),
  createdDate: z.string().datetime(),
});

export const locationServiceTimeDtoSchema = z.object({
  serviceTime: z.number(),
});

export const adminRegionLocationResDtoSchema = z.object({
  locationId: z.string(),
  locationSequence: z.number(),
  locationServiceTime: locationServiceTimeDtoSchema,
  locationTravelTime: z.number().optional(),
  timeBetweenLocations: z.number().optional(),
});

export const adminRegionResDtoSchema = z.object({
  id: z.string(),
  shiftId: z.string(),
  name: z.string(),
  color: z.string(),
  regionETA: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  suggestedDrivers: z.array(adminRegionSuggestedDriversResDtoSchema),
  locations: z.array(adminRegionLocationResDtoSchema),
  regionPriority: z.number(),
  startTime: z.string(),
});

export const adminRegionSelectOptionsSuggestedDriversResDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const adminRegionSelectOptionsResDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  suggestedDrivers: adminRegionSelectOptionsSuggestedDriversResDtoSchema,
});

export const adminRegionSuggestedDriversReqDtoSchema = z.object({
  dailyShiftDriverId: z.string(),
});

export const adminRegionLocationReqDtoSchema = z.object({
  id: z.string(),
  seqNumber: z.number(),
});

export const adminPostRegionReqDtoSchema = z.object({
  name: z.string(),
  color: z
    .string()
    .regex(
      /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/,
      "Must be a valid hex color.",
    ),
  shiftId: z.string(),
  suggestedDrivers: adminRegionSuggestedDriversReqDtoSchema,
  locations: z.array(adminRegionLocationReqDtoSchema),
});

export const adminPatchRegionLocationSequenceReqDtoSchema = z.object({
  locationId: z.string(),
  seqNumber: z.number(),
});

export const adminPatchRegionLocationsReqDtoSchema = z.object({
  locations: z.array(adminPatchRegionLocationSequenceReqDtoSchema),
  targetSeqNumber: z.number(),
  transferMode: z.union([
    z.literal("before"),
    z.literal("after"),
    z.literal("append"),
  ]),
});

export const adminRegionDeleteLocationsReqDtoSchema = z.object({
  locations: z.array(z.string()),
});

export const transferRegionResDtoSchema = z.object({
  targetRegion: adminRegionResDtoSchema,
  region: adminRegionResDtoSchema.optional(),
});

export const adminPostRegionLocationsReqDtoSchema = z.object({
  targetRegionId: z.string(),
  targetSeqNumber: z.number(),
  transferMode: z.union([
    z.literal("before"),
    z.literal("after"),
    z.literal("append"),
  ]),
  locations: z.array(z.string()),
});

export const adminRegionLocationReSequenceReqDtoSchema = z.object({
  locations: z.array(adminRegionLocationReqDtoSchema),
});

export const adminPutRegionServiceTimeReqDtoSchema = z.object({
  percentage: z.number(),
});

export const adminPutRegionReqDtoSchema = z.object({
  name: z.string(),
  color: z
    .string()
    .regex(
      /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/,
      "Must be a valid hex color.",
    ),
  shiftId: z.string().optional(),
  suggestedDrivers: adminRegionSuggestedDriversReqDtoSchema.optional(),
  startTime: z.string().optional(),
});

export const adminPutRegionPriorityReqDtoSchema = z.object({
  priority: z.number(),
});

export const adminVehicleTypeResDtoSchema = z.object({
  id: z.number(),
  typeName: z.string(),
  travelSpeed: z.number(),
  lastUpdated: z.string().datetime(),
});

export const adminVehicleResDtoSchema = z.object({
  id: z.string(),
  vehicleType: adminVehicleTypeResDtoSchema,
  licensePlate: z.string(),
  available: z.boolean(),
  travelSpeed: z.number(),
  lastPlow: z.string().datetime(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const stringSchema = z.object({});

export const adminPostVehicleReqDtoSchema = z.object({
  vehicleTypeId: z.number(),
  licensePlate: z.string(),
  available: z.boolean().optional().default(true),
});

export const adminPutVehicleReqDtoSchema = z.object({
  vehicleTypeId: z.number(),
  licensePlate: z.string(),
  available: z.boolean().default(true),
});

export const adminPostVehicleTypeReqDtoSchema = z.object({
  typeName: z.string(),
  travelSpeed: z.number(),
});

export const adminPutVehicleTypeReqDtoSchema = z.object({
  typeName: z.string(),
  travelSpeed: z.number(),
});

export const adminGetRoutesRegionResDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string().optional(),
});

export const adminGetRoutesDriverResDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const adminGetRoutesLocationCustomerOrderResDtoSchema = z.object({
  status: z
    .union([
      z.literal("skipped"),
      z.literal("regular"),
      z.literal("delayed"),
      z.literal("urgent"),
    ])
    .default("regular"),
  customerSkipOverridden: z.boolean(),
  createdAt: z.string().datetime().optional(),
});

export const adminGetRouteTravelTimeResDtoSchema = z.object({
  serviceTimeMin: z.number().optional(),
  estimatedTimeMinutes: z.number(),
  travelTimeBetweenLocations: z.number().optional(),
  encodedPolyline: z.string().optional().nullable(),
});

export const adminGetRouteLocationCustomerResDtoSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
});

export const unitResDtoSchema = z.object({
  value: z.number(),
  type: z.union([
    z.literal("distance"),
    z.literal("temperature"),
    z.literal("speed"),
  ]),
  symbol: z.string(),
});

export const measurementResDtoSchema = z.object({
  imperial: unitResDtoSchema,
  metric: unitResDtoSchema,
});

export const adminGetRoutesLocationsResDtoSchema = z.object({
  locationId: z.string(),
  locationSequence: z.number(),
  latitude: z.number().optional(),
  longitude: z.number().optional(),
  address: z.string().optional(),
  serviceTime: z.number().optional(),
  order: adminGetRoutesLocationCustomerOrderResDtoSchema.optional(),
  driverStatus: z
    .union([
      z.literal("toBePlowed"),
      z.literal("inProgress"),
      z.literal("completed"),
      z.literal("partiallyCompleted"),
      z.literal("cantPlow"),
    ])
    .optional()
    .default("toBePlowed"),
  driverStatusLastUpdatedAt: z.string().datetime().optional(),
  driverServiceStartTime: z.string().datetime().optional().nullable(),
  driverServiceEndTime: z.string().datetime().optional().nullable(),
  type: z.union([z.literal("onDemand"), z.literal("annual")]),
  travelDetails: adminGetRouteTravelTimeResDtoSchema.optional(),
  customer: adminGetRouteLocationCustomerResDtoSchema.optional(),
  locationNoteCount: z.number().optional(),
  driverStatusChangeReason: z
    .union([
      z.literal("carBlockingDriveway"),
      z.literal("obstructionBlockingDriveway"),
      z.literal("alreadyCleared"),
      z.literal("other"),
    ])
    .optional(),
  driverStatusLastUpdatedBy: z
    .union([z.literal("driver"), z.literal("admin")])
    .optional(),
  driverStatusChangeReasonComment: z.string().optional(),
  snowAmount: measurementResDtoSchema,
  severity: z
    .union([
      z.literal("rain"),
      z.literal("mixedPrecipitation"),
      z.literal("lightSnow"),
      z.literal("moderateSnow"),
      z.literal("heavySnow"),
      z.literal("noPrecipitation"),
    ])
    .optional()
    .nullable(),
  lastPlowedAt: z.string().datetime().optional().nullable(),
});

export const routeStartingPointDtoSchema = z.object({
  lat: z.number(),
  lng: z.number(),
  address: z.string(),
  estTimeToFirstLocationMinutes: z.string(),
});

export const adminGetRouteNotificationsResDtoSchema = z.object({
  eta: z.boolean(),
  serviceDelayed: z.boolean(),
  statusUpdate: z.boolean(),
  serviceModified: z.boolean(),
  minutesBeforeService: z.number(),
});

export const adminGetRoutesResDtoSchema = z.object({
  id: z.string(),
  routeName: z.string().optional().nullable(),
  color: z.string().optional().nullable(),
  regionId: z.string().optional().nullable(),
  region: adminGetRoutesRegionResDtoSchema.optional(),
  driverId: z.string().optional().nullable(),
  driver: adminGetRoutesDriverResDtoSchema.optional(),
  availableForAnyDriver: z.boolean().optional(),
  vehicleId: z.string().optional().nullable(),
  date: z.string().datetime(),
  routePriority: z.number().optional(),
  priorityByDriver: z.number().optional(),
  state: z.union([
    z.literal("planning"),
    z.literal("planned"),
    z.literal("live"),
    z.literal("ended"),
  ]),
  startTime: z.string(),
  isLocked: z.boolean().optional(),
  isVirtual: z.boolean(),
  locations: z.array(adminGetRoutesLocationsResDtoSchema).optional(),
  skippedLocationCount: z.number().optional(),
  travelDetails: adminGetRouteTravelTimeResDtoSchema.optional(),
  startingPoint: routeStartingPointDtoSchema.optional(),
  notificationSettings: adminGetRouteNotificationsResDtoSchema.optional(),
});

export const adminGetRouteStatusesPerMonthResDtoSchema = z.object({
  state: z.union([
    z.literal("planning"),
    z.literal("planned"),
    z.literal("live"),
    z.literal("ended"),
  ]),
  date: z.string().datetime(),
});

export const adminGetDateOfRoutesByStateResDtoSchema = z.object({
  date: z.string().optional().nullable(),
});

export const adminGetDateRouteNotificationsResDtoSchema = z.object({
  eta: z.boolean(),
  serviceDelayed: z.boolean(),
  serviceModified: z.boolean(),
  statusUpdate: z.boolean(),
  minutesBeforeService: z.boolean(),
  date: z.string().datetime(),
  updatedAt: z.string().datetime().optional(),
});

export const adminPostRouteReqDtoSchema = z.object({
  date: z.string().optional().default("Today"),
  routeName: z.string(),
  routePriority: z.number(),
  color: z.string(),
  driverId: z.string().optional().nullable(),
  availableForAnyDriver: z.boolean().optional().nullable(),
  startTime: z.string(),
});

export const adminPutRouteNotificationsReqDtoSchema = z.object({
  eta: z.boolean(),
  serviceDelayed: z.boolean(),
  statusUpdate: z.boolean(),
  minutesBeforeService: z.boolean(),
  serviceModified: z.boolean(),
});

export const locationReqDtoSchema = z.object({
  locationId: z.string(),
  seqNumber: z.number(),
});

export const adminPostTransferLocationsToRouteReqDtoSchema = z.object({
  targetDate: z.string(),
  targetRouteId: z.string(),
  targetSeqNumber: z.number(),
  targetRouteOrderStatus: z.union([
    z.literal("skipped"),
    z.literal("regular"),
    z.literal("delayed"),
    z.literal("urgent"),
  ]),
  transferMode: z.union([z.literal("before"), z.literal("after")]),
  locationIds: z.array(locationReqDtoSchema),
});

export const adminPatchRouteLocationSequenceReverseReqDtoSchema = z.object({
  selectedRouteLocationIds: z.array(z.string()),
});

export const adminGetLocationsRouteResDtoSchema = z.object({
  id: z.string(),
  state: z.union([
    z.literal("planning"),
    z.literal("planned"),
    z.literal("live"),
    z.literal("ended"),
  ]),
  regionName: z.string().optional(),
  regionColor: z.string().optional(),
});

export const adminGetSelectedRouteLocationsResDtoSchema = z.object({
  id: z.string(),
  latitude: z.number(),
  longitude: z.number(),
  address: z.string(),
  locationSequence: z.number(),
  customer: adminGetRouteLocationCustomerResDtoSchema.optional(),
  route: adminGetLocationsRouteResDtoSchema,
  order: adminGetRoutesLocationCustomerOrderResDtoSchema,
  travelDetails: adminGetRouteTravelTimeResDtoSchema.optional(),
  snowAmount: measurementResDtoSchema,
  severity: z
    .union([
      z.literal("rain"),
      z.literal("mixedPrecipitation"),
      z.literal("lightSnow"),
      z.literal("moderateSnow"),
      z.literal("heavySnow"),
      z.literal("noPrecipitation"),
    ])
    .optional()
    .nullable(),
  lastPlowedAt: z.string().datetime().optional().nullable(),
});

export const adminGetSelectedRoutesLocationsInfoReqDtoSchema = z.object({
  locations: z.array(z.string()),
});

export const adminGetRouteOrdersResDtoSchema = z.object({
  date: z.string().datetime(),
  status: z
    .union([
      z.literal("skipped"),
      z.literal("regular"),
      z.literal("delayed"),
      z.literal("urgent"),
    ])
    .default("regular"),
  locationId: z.string(),
  customerId: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const adminGetRoutesLocationsInfoReqDtoSchema = z.object({
  locations: z.array(z.string()),
  status: z
    .union([
      z.literal("skipped"),
      z.literal("regular"),
      z.literal("delayed"),
      z.literal("urgent"),
    ])
    .default("regular"),
});

export const adminPostRouteLocationDriverStatusesResDtoSchema = z.object({
  locationId: z.string(),
  date: z.string(),
  status: z.string(),
});

export const adminPostRouteLocationDriverStatusesReqDtoSchema = z.object({
  timezone: z.string().optional(),
  locations: z.array(z.string()),
  status: z.union([
    z.literal("toBePlowed"),
    z.literal("inProgress"),
    z.literal("completed"),
    z.literal("partiallyCompleted"),
    z.literal("cantPlow"),
  ]),
});

export const adminPutRoutePriorityReqDtoSchema = z.object({
  priority: z.number(),
});

export const adminPatchRouteStartTimeReqDtoSchema = z.object({
  startTime: z.string(),
  timezone: z.string().optional(),
});

export const adminPutRouteResDtoSchema = z.object({
  id: z.string(),
  routeName: z.string().optional().nullable(),
  color: z.string().optional().nullable(),
  regionId: z.string().optional().nullable(),
  region: adminGetRoutesRegionResDtoSchema.optional(),
  availableForAnyDriver: z.boolean(),
  driverId: z.string().optional().nullable(),
  driver: adminGetRoutesDriverResDtoSchema.optional(),
  vehicleId: z.string().optional().nullable(),
  travelDetails: adminGetRouteTravelTimeResDtoSchema.optional(),
  startingPoint: routeStartingPointDtoSchema.optional(),
  date: z.string().datetime(),
  routePriority: z.number().optional().nullable(),
  state: z.union([
    z.literal("planning"),
    z.literal("planned"),
    z.literal("live"),
    z.literal("ended"),
  ]),
  startTime: z.string(),
  locations: z.array(adminGetRoutesLocationsResDtoSchema).optional(),
  createdAt: z.string().datetime().optional().nullable(),
  updatedAt: z.string().datetime().optional().nullable(),
  isLocked: z.boolean().optional().default(false),
  isVirtual: z.boolean().optional().default(false),
});

export const adminPutRouteReqDtoSchema = z.object({
  driverId: z.string().optional().nullable(),
  availableForAnyDriver: z.boolean().nullable(),
  startTime: z.string(),
  timezone: z.string().optional(),
});

export const adminPatchRouteLockReqDtoSchema = z.object({
  isLocked: z.boolean(),
});

export const adminPatchRouteLockResDtoSchema = z.object({
  isLocked: z.boolean(),
  date: z.string(),
});

export const adminPatchRouteStateResDtoSchema = z.object({
  isLocked: z.boolean(),
  toBePlowedCount: z.number().optional(),
  date: z.string(),
  state: z.union([
    z.literal("planning"),
    z.literal("planned"),
    z.literal("live"),
    z.literal("ended"),
  ]),
});

export const adminPatchRevertStateReqDtoSchema = z.object({
  state: z.string(),
});

export const adminGetRouteStateDiffResDtoSchema = z.object({
  hasChanges: z.boolean(),
  stateDiff: z.record(z.any()),
});

export const locationNoteModifierDtoSchema = z.object({
  name: z.string(),
  email: z.string(),
});

export const locationNoteDtoSchema = z.object({
  id: z.string(),
  content: z.string(),
  mustRead: z.boolean().optional(),
  locationId: z.string(),
  driverId: z.record(z.any()).nullable(),
  driver: locationNoteModifierDtoSchema,
  adminId: z.record(z.any()).nullable(),
  admin: locationNoteModifierDtoSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime().optional().nullable(),
});

export const adminLocationDetailsResDtoSchema = z.object({
  onsiteContactName: z.record(z.any()).optional(),
  onsiteContactEmail: z.record(z.any()).optional(),
  contractPrice: z.record(z.any()).optional(),
  billingAddress: z.record(z.any()).optional(),
  financialNotes: z.record(z.any()).optional(),
  squareFootage: z.record(z.any()).optional(),
  slope: z
    .union([z.literal("flat"), z.literal("upslope"), z.literal("downslope")])
    .optional(),
  condition: z
    .union([
      z.literal("poor"),
      z.literal("fair"),
      z.literal("good"),
      z.literal("new"),
    ])
    .optional(),
  difficulty: z.record(z.any()).optional(),
});

export const adminLocationPlowSkipReportSummaryResDtoSchema = z.object({
  customerCount: z.number(),
  operatorCount: z.number(),
  customerDelayedCount: z.number(),
  operatorDelayedCount: z.number(),
});

export const adminLocationPlowSkipReportEntryResDtoSchema = z.object({
  date: z.string(),
  customerSkipped: z.boolean(),
  operatorSkipped: z.boolean(),
  customerDelayed: z.boolean(),
  operatorDelayed: z.boolean(),
});

export const adminLocationPlowSkipReportResDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  summary: adminLocationPlowSkipReportSummaryResDtoSchema,
  entries: z.array(adminLocationPlowSkipReportEntryResDtoSchema),
});

export const adminLocationWithCustomerResDtoSchema = z.object({
  id: z.string(),
  customerId: z.string(),
  address: z.string(),
  street: z.string(),
  city: z.string(),
  zipCode: z.string(),
  state: z.string(),
  type: z.union([z.literal("onDemand"), z.literal("annual")]),
  reportsEnabled: z.boolean(),
  billingInformation: z.string(),
  notes: z.string(),
  serviceTime: z.number(),
  elevation: measurementResDtoSchema,
  region: adminRegionResDtoSchema,
  serviceAccess: z.boolean(),
  locationDetails: adminLocationDetailsResDtoSchema.optional(),
  plowSkipReport: adminLocationPlowSkipReportResDtoSchema.optional(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  emailConfirmed: z.boolean(),
});

export const adminCsvUploadStatTmpLocationCustomerResDtoSchema = z.object({
  newAddressAndCustomer: z.number(),
  existingAddressNewCustomer: z.number(),
  updateCustomerOnExistingAddress: z.number(),
  updateAddressOfExistingCustomer: z.number(),
  existingCustomerNewAddress: z.number(),
});

export const adminCsvUploadStatResDtoSchema = z.object({
  isProcessing: z.boolean(),
  hasAccepted: z.boolean().optional(),
  tmpLocationCustomer:
    adminCsvUploadStatTmpLocationCustomerResDtoSchema.optional(),
});

export const adminLocationResDtoSchema = z.object({
  id: z.string(),
  customerId: z.string(),
  address: z.string(),
  street: z.string(),
  city: z.string(),
  zipCode: z.string(),
  state: z.string(),
  type: z.union([z.literal("onDemand"), z.literal("annual")]),
  reportsEnabled: z.boolean(),
  billingInformation: z.string(),
  notes: z.string(),
  serviceTime: z.number(),
  elevation: measurementResDtoSchema,
  region: adminRegionResDtoSchema,
  serviceAccess: z.boolean(),
  locationDetails: adminLocationDetailsResDtoSchema.optional(),
  plowSkipReport: adminLocationPlowSkipReportResDtoSchema.optional(),
});

export const adminPutLocationDetailsReqDtoSchema = z.object({
  onsiteContactName: z.string().optional(),
  onsiteContactEmail: z.string().optional(),
  contractPrice: z.number().optional(),
  billingAddress: z.string().optional(),
  financialNotes: z.string().optional(),
  squareFootage: z.number().optional(),
  slope: z
    .union([z.literal("flat"), z.literal("upslope"), z.literal("downslope")])
    .optional(),
  condition: z
    .union([
      z.literal("poor"),
      z.literal("fair"),
      z.literal("good"),
      z.literal("new"),
    ])
    .optional(),
  difficulty: z.number().min(1).max(5).optional(),
});

export const adminPostLocationReqDtoSchema = z.object({
  customerId: z.string().uuid(),
  address: z.string(),
  type: z.union([z.literal("onDemand"), z.literal("annual")]),
  reportsEnabled: z.boolean().optional(),
  notes: z.string().optional(),
  billingInformation: z.string().optional(),
  serviceTime: z.number().min(0),
  regionId: z.string().optional(),
  locationDetails: adminPutLocationDetailsReqDtoSchema.optional(),
});

export const csvLocationResponseDtoSchema = z.object({
  message: z.string(),
  recordCount: z.number(),
});

export const acceptChangesFromCsvDtoSchema = z.object({
  newAddressAndCustomer: z.boolean(),
  existingAddressNewCustomer: z.boolean(),
  updateCustomerOnExistingAddress: z.boolean(),
  updateAddressOfExistingCustomer: z.boolean(),
  existingCustomerNewAddress: z.boolean(),
});

export const adminPutLocationReqDtoSchema = z.object({
  notes: z.string().optional(),
  serviceTime: z.number().min(0).optional(),
  type: z.union([z.literal("onDemand"), z.literal("annual")]).optional(),
  reportsEnabled: z.boolean().optional(),
  billingInformation: z.string().optional(),
  regionId: z.string().optional(),
  serviceAccess: z.boolean().optional(),
  locationDetails: adminPutLocationDetailsReqDtoSchema.optional(),
});

export const adminLocationServiceTimeResDtoSchema = z.object({
  serviceTime: z.number(),
});

export const adminPutLocationServiceTimeReqDtoSchema = z.object({
  serviceTime: z.number().min(0),
});

export const adminDeleteManyLocationsFailureDtoSchema = z.object({
  id: z.string(),
  message: z.string(),
});

export const adminDeleteManyLocationsResDtoSchema = z.object({
  deleted: z.array(adminLocationResDtoSchema),
  failed: z.array(adminDeleteManyLocationsFailureDtoSchema),
});

export const adminDeleteManyLocationsReqDtoSchema = z.object({
  id: z.string(),
});

export const adminPatchManyLocationServiceAccessReqDtoSchema = z.object({
  id: z.string(),
  serviceAccess: z.boolean(),
});

export const adminPutLocationServiceAccessReqDtoSchema = z.object({
  serviceAccess: z.boolean(),
});

export const adminShortLocationResDtoSchema = z.object({
  id: z.string(),
  customerId: z.string(),
  address: z.string(),
  type: z.union([z.literal("onDemand"), z.literal("annual")]),
});

export const adminLocationLocationActionResDtoSchema = z.object({
  id: z.string(),
  status: z.string(),
  submittedStatus: z.string(),
  overrideStatus: z.string(),
  date: z.string(),
});

export const adminLocationEligibilityResDtoSchema = z.object({
  id: z.string(),
  customerId: z.string(),
  address: z.string(),
  type: z.union([z.literal("onDemand"), z.literal("annual")]),
  name: z.string(),
  locationAction: adminLocationLocationActionResDtoSchema,
  notes: z.string(),
  elevation: measurementResDtoSchema,
  serviceTime: z.number(),
});

export const adminLocationEligibilityStatisticsResDtoSchema = z.object({
  home: z.number(),
  away: z.number(),
  delayed: z.number(),
  annualUrgent: z.number(),
  earlyPlow: z.number(),
  latePlow: z.number(),
  onDemandUrgent: z.number(),
});

export const adminAllLocationsCustomerResDtoSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  serviceAccess: z.boolean(),
  emailVerified: z.boolean(),
});

export const adminAllLocationsRegionResDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string().optional().nullable(),
});

export const adminAllLocationsResDtoSchema = z.object({
  id: z.string(),
  latitude: z.number(),
  longitude: z.number(),
  locationSequence: z.number().optional().nullable(),
  address: z.string(),
  customer: adminAllLocationsCustomerResDtoSchema,
  region: adminAllLocationsRegionResDtoSchema.optional(),
  type: z.union([z.literal("onDemand"), z.literal("annual")]).optional(),
  reportsEnabled: z.boolean().optional(),
  serviceTime: z.number().optional(),
  serviceAccess: z.boolean().optional(),
  locationNoteCount: z.number().optional(),
});

export const adminLocationsInfoCustomerResDtoSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
});

export const adminLocationsInfoResDtoSchema = z.object({
  locationId: z.string(),
  latitude: z.number(),
  longitude: z.number(),
  address: z.string(),
  serviceTime: z.number(),
  serviceTimeStr: z.string(),
  type: z.string(),
  customer: adminLocationsInfoCustomerResDtoSchema,
});

export const adminLocationsInfoReqDtoSchema = z.object({
  locations: z.array(z.string()),
});

export const adminLocationCustomerResDtoSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  serviceAccess: z.boolean(),
  email: z.string(),
});

export const adminLocationResV2DtoSchema = z.object({
  id: z.string(),
  latitude: z.number(),
  longitude: z.number(),
  address: z.string(),
  serviceTime: z.number().optional(),
  notes: z.record(z.any()).optional(),
  isDefault: z.boolean().optional(),
  customer: adminLocationCustomerResDtoSchema,
  type: z.union([z.literal("onDemand"), z.literal("annual")]).optional(),
  serviceAccess: z.boolean(),
  reportsEnabled: z.boolean().optional(),
  billingInformation: z.record(z.any()).optional(),
  locationDetails: adminLocationDetailsResDtoSchema.optional(),
});

export const adminCreateLocationWithCustomerReqDtoSchema = z.object({
  onsiteContactName: z.string().optional(),
  onsiteContactEmail: z.string().optional(),
  contractPrice: z.number().optional(),
  billingAddress: z.string().optional(),
  financialNotes: z.string().optional(),
  squareFootage: z.number().optional(),
  slope: z
    .union([z.literal("flat"), z.literal("upslope"), z.literal("downslope")])
    .optional(),
  condition: z
    .union([
      z.literal("poor"),
      z.literal("fair"),
      z.literal("good"),
      z.literal("new"),
    ])
    .optional(),
  difficulty: z.number().min(1).max(5).optional(),
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  phone: z
    .string()
    .regex(/^[\+]?[1-9]?\d{1,16}$/, "Must be a valid phone number.")
    .optional(),
  address: z.string(),
  serviceTime: z.number().min(0),
  notes: z.string().optional(),
  type: z.union([z.literal("onDemand"), z.literal("annual")]).optional(),
  reportsEnabled: z.boolean().optional(),
  billingInformation: z.string().optional(),
  leadId: z.string().uuid().optional(),
});

export const adminPostCustomerReqDtoSchema = z.object({
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  phone: z
    .string()
    .regex(/^[\+]?[1-9]?\d{1,16}$/, "Must be a valid phone number.")
    .optional(),
  serviceAccess: z.boolean().optional(),
});

export const adminPutCustomerReqDtoSchema = z.object({
  email: z.string().email().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phone: z
    .string()
    .regex(/^[\+]?[1-9]?\d{1,16}$/, "Must be a valid phone number.")
    .optional(),
  serviceAccess: z.boolean().optional(),
});

export const adminPatchManyCustomerAppAccessReqDtoSchema = z.object({
  id: z.string(),
  serviceAccess: z.boolean(),
});

export const adminPutCustomerAppAccessReqDtoSchema = z.object({
  serviceAccess: z.boolean(),
});

export const adminAccountResDtoSchema = z.object({
  id: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  role: z.union([
    z.literal("customer"),
    z.literal("admin"),
    z.literal("driver"),
    z.literal("super_admin"),
  ]),
  organizationId: z.record(z.any()).optional(),
  hasSetPassword: z.boolean(),
  hadIntroduction: z.boolean(),
  createdAt: z.string().datetime(),
  lastActiveAt: z.string().datetime(),
  isActive: z.boolean(),
});

export const adminPostAccountPasswordResetReqDtoSchema = z.object({
  oldPassword: z.string().min(4),
  newPassword: z.string().min(4),
});

export const adminPatchAccountStatusReqDtoSchema = z.object({
  isActive: z.boolean(),
});

export const createLocationNoteDtoSchema = z.object({
  content: z.string(),
  mustRead: z.boolean().optional(),
});

export const updateLocationNoteDtoSchema = z.object({
  content: z.string().optional(),
  mustRead: z.boolean().optional(),
});

export const adminPostPlowReportReqDtoSchema = z.object({
  locations: z.array(z.string()),
  from: z.string(),
  to: z.string(),
});

export const adminPostDailyRoutePlowReportReqDtoSchema = z.object({
  date: z.string(),
});

export const driverStartingPointDtoSchema = z.object({
  address: z.string(),
  lat: z.number(),
  lng: z.number(),
});

export const adminDriverVehicleViewDtoSchema = z.object({
  licensePlate: z.string(),
  lastPlow: z.string().datetime(),
  available: z.boolean(),
});

export const adminDriverResViewDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().optional(),
  username: z.string().optional(),
  startingPoint: driverStartingPointDtoSchema,
  available: z.boolean(),
  performanceTime: z.number(),
  vehicleId: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  driverCompletedRegistration: z.boolean(),
  appAccess: z.boolean(),
  vehicle: adminDriverVehicleViewDtoSchema,
});

export const adminDriverSuggestedRegionDtoSchema = z.object({
  regionId: z.string(),
  regionName: z.string(),
  mode: z.string(),
});

export const adminDriverResDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().optional(),
  username: z.string().optional(),
  startingPoint: driverStartingPointDtoSchema,
  available: z.boolean(),
  performanceTime: z.number(),
  vehicleId: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  driverCompletedRegistration: z.boolean(),
  appAccess: z.boolean(),
  invited: z.string().datetime(),
  vehicle: adminVehicleResDtoSchema,
  suggestedRegions: z.array(adminDriverSuggestedRegionDtoSchema).optional(),
});

export const adminPostDriverReqDtoSchema = z.object({
  name: z.string().optional(),
  email: z.string().optional(),
  username: z.string().optional(),
  password: z.string().optional(),
  startingPoint: z.string().optional(),
  available: z.boolean().optional().default(true),
  vehicleId: z.string().optional(),
  performanceTime: z.number().optional(),
  regionIds: z.array(z.string()).optional(),
});

export const adminPutDriverReqDtoSchema = z.object({
  name: z.string(),
  email: z.string().optional(),
  password: z.string().optional(),
  appAccess: z.boolean(),
  regionIds: z.array(z.string()).optional(),
  startingPoint: z.string(),
  available: z.boolean().optional().default(true),
  vehicleId: z.string().nullable(),
  performanceTime: z.number(),
});

export const adminDeleteDriverResDtoSchema = z.object({
  id: z.string(),
  warnMessage: z.string(),
});

export const adminPutDriverAppAccessReqDtoSchema = z.object({
  appAccess: z.boolean(),
});

export const guestSentNotificationRecipientResDtoSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  seen: z.boolean(),
  createdAt: z.string(),
  subscriptionType: z.union([
    z.literal("workwave"),
    z.literal("noaa"),
    z.literal("notification"),
  ]),
});

export const currentCustomerSchema = z.object({
  id: z.string(),
  email: z.string(),
  googleMapsApiKey: z.string().optional(),
  appAccess: z.boolean(),
  customerId: z.string(),
});

export const adminLoginResDtoSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  jti: z.string(),
  customer: currentCustomerSchema,
  role: z.union([
    z.literal("customer"),
    z.literal("admin"),
    z.literal("driver"),
    z.literal("super_admin"),
  ]),
  organizationId: z.record(z.any()).nullable(),
  organization: currentOrganizationResDtoSchema.optional(),
  isImpersonating: z.boolean(),
  impersonatedBy: z.record(z.any()).nullable(),
});

export const adminLoginReqDtoSchema = z.object({
  email: z.string().email(),
  password: z.string(),
});

export const adminRefreshReqDtoSchema = z.object({
  refreshToken: z
    .string()
    .regex(/^(?:[w-]*.){2}[w-]*$/, "Must be a valid JWT."),
});

export const adminSessionResDtoSchema = z.object({
  customer: currentCustomerSchema,
  role: z.union([
    z.literal("customer"),
    z.literal("admin"),
    z.literal("driver"),
    z.literal("super_admin"),
  ]),
  organizationId: z.record(z.any()).nullable(),
  organization: currentOrganizationResDtoSchema.optional(),
  isImpersonating: z.boolean(),
  impersonatedBy: z.record(z.any()).nullable(),
});

export const adminEmailResDtoSchema = z.object({
  email: z.string().email(),
});

export const adminForgotPasswordReqDtoSchema = z.object({
  email: z.string().email(),
});

export const adminResetPasswordReqDtoSchema = z.object({
  token: z.string().uuid(),
  password: z.string().min(4),
});

export const adminRegisterInviteReqDtoSchema = z.object({
  email: z.string().email(),
  token: z.string().uuid(),
  password: z.string().min(4),
  confirmPassword: z.string().min(4),
});

export const adminRegisterAdminReqDtoSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  password: z.string(),
  organizationId: z.string().uuid(),
});

export const appLoginResDtoSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  jti: z.string(),
  customer: currentCustomerSchema,
  role: z.union([
    z.literal("customer"),
    z.literal("admin"),
    z.literal("driver"),
    z.literal("super_admin"),
  ]),
  organizationId: z.record(z.any()).nullable(),
  organization: currentOrganizationResDtoSchema.optional(),
});

export const appResetPasswordReqDtoSchema = z.object({
  token: z.string().uuid(),
  password: z.string().min(4),
});

export const currentDriverSchema = z.object({
  id: z.string(),
  email: z.string().optional(),
  username: z.string().optional(),
  googleMapsApiKey: z.string().optional(),
  appAccess: z.boolean(),
  driverId: z.string(),
});

export const driverLoginResDtoSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  jti: z.string(),
  driver: currentDriverSchema,
  role: z.union([
    z.literal("customer"),
    z.literal("admin"),
    z.literal("driver"),
    z.literal("super_admin"),
  ]),
  organizationId: z.record(z.any()).nullable(),
  organization: currentOrganizationResDtoSchema.optional(),
});

export const driverRegisterReqDtoSchema = z.object({
  email: z.string().email(),
  password: z.string().min(4),
  registrationToken: z.string(),
});

export const driverResetPasswordReqDtoSchema = z.object({
  token: z.string().uuid(),
  password: z.string().min(4),
});

export const adminPostAdminInviteReqDtoSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  role: z.union([z.literal("admin"), z.literal("super_admin")]),
});

export const adminLeadListResDtoSchema = z.object({
  id: z.string(),
  fullName: z.string(),
  email: z.string(),
  address: z.string(),
  phoneNumber: z.string(),
  createdAt: z.string().datetime(),
  source: z.union([z.literal("manual"), z.literal("inquiry_form")]),
  customerId: z.record(z.any()).optional(),
});

export const adminLeadsPaginatedMetaDataDtoSchema = z.object({
  totalPages: z.number(),
  page: z.number(),
  limit: z.number(),
  count: z.number(),
  matchingCustomerLocationCount: z.number().optional(),
});

export const adminImportLeadsCsvRowErrorDtoSchema = z.object({
  row: z.number(),
  errors: z.array(z.string()),
});

export const adminImportLeadsCsvResDtoSchema = z.object({
  createdCount: z.number(),
  skipped: z.array(adminImportLeadsCsvRowErrorDtoSchema),
});

export const adminLeadResDtoSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  fullName: z.string(),
  email: z.string(),
  phoneNumber: z.string(),
  address: z.string(),
  onsiteContactName: z.record(z.any()).optional(),
  onsiteContactEmail: z.record(z.any()).optional(),
  contractPrice: z.record(z.any()).optional(),
  billingAddress: z.record(z.any()).optional(),
  financialNotes: z.record(z.any()).optional(),
  squareFootage: z.record(z.any()).optional(),
  slope: z
    .union([z.literal("flat"), z.literal("upslope"), z.literal("downslope")])
    .optional(),
  condition: z
    .union([
      z.literal("poor"),
      z.literal("fair"),
      z.literal("good"),
      z.literal("new"),
    ])
    .optional(),
  difficulty: z.record(z.any()).optional(),
  notes: z.record(z.any()).optional(),
  source: z.union([z.literal("manual"), z.literal("inquiry_form")]),
  customerId: z.record(z.any()).optional(),
  locationId: z.record(z.any()).optional(),
  createdAt: z.string().datetime(),
});

export const adminPostLeadReqDtoSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  phoneNumber: z
    .string()
    .regex(/^[\+]?[1-9]?\d{1,16}$/, "Must be a valid phone number."),
  address: z.string(),
  onsiteContactName: z.string().optional(),
  onsiteContactEmail: z.string().optional(),
  contractPrice: z.number().optional(),
  billingAddress: z.string().optional(),
  financialNotes: z.string().optional(),
  squareFootage: z.number().optional(),
  slope: z
    .union([z.literal("flat"), z.literal("upslope"), z.literal("downslope")])
    .optional(),
  condition: z
    .union([
      z.literal("poor"),
      z.literal("fair"),
      z.literal("good"),
      z.literal("new"),
    ])
    .optional(),
  difficulty: z.number().min(1).max(5).optional(),
  notes: z.string().optional(),
});

export const adminPutLeadReqDtoSchema = z.object({
  onsiteContactName: z.string().optional(),
  onsiteContactEmail: z.string().optional(),
  contractPrice: z.number().optional(),
  billingAddress: z.string().optional(),
  financialNotes: z.string().optional(),
  squareFootage: z.number().optional(),
  slope: z
    .union([z.literal("flat"), z.literal("upslope"), z.literal("downslope")])
    .optional(),
  condition: z
    .union([
      z.literal("poor"),
      z.literal("fair"),
      z.literal("good"),
      z.literal("new"),
    ])
    .optional(),
  difficulty: z.number().min(1).max(5).optional(),
  notes: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().email().optional(),
  phoneNumber: z
    .string()
    .regex(/^[\+]?[1-9]?\d{1,16}$/, "Must be a valid phone number.")
    .optional(),
  address: z.string().optional(),
});

export const adminDeleteManyLeadsResDtoSchema = z.object({
  deletedCount: z.number(),
  skippedIds: z.array(z.string()),
});

export const adminDeleteManyLeadsReqDtoSchema = z.object({
  ids: z.array(z.string()),
});

export const adminLocationActionResDtoSchema = z.object({
  id: z.string(),
  status: z.union([
    z.literal("delayed"),
    z.literal("away"),
    z.literal("earlyPlow"),
    z.literal("latePlow"),
    z.literal("urgent"),
  ]),
  submittedStatus: z.union([
    z.literal("home"),
    z.literal("delayed"),
    z.literal("away"),
    z.literal("earlyPlow"),
    z.literal("latePlow"),
    z.literal("urgent"),
  ]),
  overrideStatus: z.union([
    z.literal("home"),
    z.literal("delayed"),
    z.literal("away"),
    z.literal("earlyPlow"),
    z.literal("latePlow"),
    z.literal("urgent"),
  ]),
  date: z.string(),
  locationId: z.string(),
});

export const adminPostLocationActionReqDtoSchema = z.object({
  overrideStatus: z.union([
    z.literal("home"),
    z.literal("delayed"),
    z.literal("away"),
    z.literal("earlyPlow"),
    z.literal("latePlow"),
    z.literal("urgent"),
  ]),
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Must be in YYYY-MM-DD format."),
  locationId: z.string().uuid(),
});

export const adminPutLocationActionReqDtoSchema = z.object({
  overrideStatus: z.union([
    z.literal("home"),
    z.literal("delayed"),
    z.literal("away"),
    z.literal("earlyPlow"),
    z.literal("latePlow"),
    z.literal("urgent"),
  ]),
});

export const adminWeatherReportElevationLevelResDtoSchema = z.object({
  id: z.string(),
  min: z.number(),
  max: z.number(),
  snowAmount: measurementResDtoSchema,
});

export const adminWeatherReportResDtoSchema = z.object({
  id: z.string(),
  groupId: z.string().optional().nullable(),
  snowAmount: measurementResDtoSchema.optional(),
  locationId: z.string().optional().nullable(),
  elevationMin: z.number().optional().nullable(),
  elevationMax: z.number().optional().nullable(),
  elevationLevels: z
    .array(adminWeatherReportElevationLevelResDtoSchema)
    .optional()
    .nullable(),
  severity: z.union([
    z.literal("rain"),
    z.literal("mixedPrecipitation"),
    z.literal("lightSnow"),
    z.literal("moderateSnow"),
    z.literal("heavySnow"),
    z.literal("noPrecipitation"),
  ]),
  createdAt: z.string(),
  updatedAt: z.string(),
  elevation: measurementResDtoSchema.optional(),
  address: z.string().optional().nullable(),
  reporter: z.string().optional().nullable(),
});

export const adminPostWeatherReportElevationLevelReqDtoSchema = z.object({
  min: z.number(),
  max: z.number(),
  snowAmount: z.number(),
});

export const adminPostWeatherReportReqDtoSchema = z.object({
  severity: z.union([
    z.literal("rain"),
    z.literal("mixedPrecipitation"),
    z.literal("lightSnow"),
    z.literal("moderateSnow"),
    z.literal("heavySnow"),
    z.literal("noPrecipitation"),
  ]),
  locationId: z.string().uuid().optional(),
  snowAmount: z.number().optional(),
  elevationLevels: z
    .array(adminPostWeatherReportElevationLevelReqDtoSchema)
    .optional(),
  measurementSystem: z.union([z.literal("imperial"), z.literal("metric")]),
});

export const adminPutWeatherReportElevationLevelReqDtoSchema = z.object({
  id: z.string().uuid(),
  min: z.number(),
  max: z.number(),
  snowAmount: z.number(),
});

export const adminPutWeatherReportReqDtoSchema = z.object({
  severity: z.union([
    z.literal("rain"),
    z.literal("mixedPrecipitation"),
    z.literal("lightSnow"),
    z.literal("moderateSnow"),
    z.literal("heavySnow"),
    z.literal("noPrecipitation"),
  ]),
  snowAmount: z.number().optional(),
  elevationLevels: z
    .array(adminPutWeatherReportElevationLevelReqDtoSchema)
    .optional(),
  measurementSystem: z.union([z.literal("imperial"), z.literal("metric")]),
});

export const adminElevationLevelResDtoSchema = z.object({
  id: z.string(),
  min: z.number(),
  max: z.number(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const adminPostElevationLevelReqDtoSchema = z.object({
  min: z.number(),
  max: z.number(),
});

export const adminPutElevationLevelReqDtoSchema = z.object({
  min: z.number(),
  max: z.number(),
});

export const dailyWeatherForecastTemperatureDtoSchema = z.object({
  low: measurementResDtoSchema,
  high: measurementResDtoSchema,
});

export const windResDtoSchema = z.object({
  direction: z.number(),
  speed: measurementResDtoSchema,
});

export const dailyWeatherForecastInfoSchema = z.object({
  temperature: dailyWeatherForecastTemperatureDtoSchema,
  wind: windResDtoSchema,
  type: z.string(),
  snow: measurementResDtoSchema,
});

export const adminDailyWeatherForecastResDtoSchema = z.object({
  date: z.string(),
  day: dailyWeatherForecastInfoSchema,
  night: dailyWeatherForecastInfoSchema,
});

export const adminHourlyWeatherForecastResDtoSchema = z.object({
  startTime: z.string(),
  endTime: z.string(),
  temperature: measurementResDtoSchema,
  wind: windResDtoSchema,
  type: z.string(),
});

export const adminDailySnowfallAmountResDtoSchema = z.object({
  date: z.string(),
  day: measurementResDtoSchema,
  night: measurementResDtoSchema,
});

export const guestDailyWeatherForecastResDtoSchema = z.object({
  date: z.string(),
  day: dailyWeatherForecastInfoSchema.optional(),
  night: dailyWeatherForecastInfoSchema.optional(),
});

export const adminNotificationResDtoSchema = z.object({
  id: z.string(),
  date: z.string(),
  title: z.string(),
  description: z.string(),
  type: z.array(z.union([z.literal("push"), z.literal("email")])),
  deliveryType: z.union([
    z.literal("instant"),
    z.literal("scheduled"),
    z.literal("recurring"),
  ]),
  recipientCount: z.number().optional(),
  endDate: z.string().datetime().optional(),
  recurrence: z
    .union([
      z.literal("daily"),
      z.literal("weekly"),
      z.literal("everyWeekday"),
      z.literal("monthly"),
      z.literal("yearly"),
      z.literal("custom"),
    ])
    .optional(),
  customPeriod: z
    .union([
      z.literal("day"),
      z.literal("week"),
      z.literal("month"),
      z.literal("year"),
    ])
    .optional(),
  customInterval: z.number().optional(),
  customWeekday: z.array(z.number()).optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  lastSent: z.string().optional(),
  paused: z.boolean(),
});

export const adminPostNotificationReqDtoSchema = z.object({
  title: z.string(),
  description: z.string(),
  type: z.array(z.union([z.literal("push"), z.literal("email")])),
  deliveryType: z.union([
    z.literal("instant"),
    z.literal("scheduled"),
    z.literal("recurring"),
  ]),
  date: z.string().datetime().optional(),
  endDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Must be in YYYY-MM-DD format.")
    .optional(),
  recurrence: z
    .union([
      z.literal("daily"),
      z.literal("weekly"),
      z.literal("everyWeekday"),
      z.literal("monthly"),
      z.literal("yearly"),
      z.literal("custom"),
    ])
    .optional(),
  customPeriod: z
    .union([
      z.literal("day"),
      z.literal("week"),
      z.literal("month"),
      z.literal("year"),
    ])
    .optional(),
  customInterval: z.number().optional(),
  customWeekday: z.array(z.number()).optional(),
  paused: z.boolean().optional(),
});

export const adminPutNotificationReqDtoSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
  type: z.array(z.union([z.literal("push"), z.literal("email")])).optional(),
  deliveryType: z
    .union([
      z.literal("instant"),
      z.literal("scheduled"),
      z.literal("recurring"),
    ])
    .optional(),
  date: z.string().datetime().optional(),
  endDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Must be in YYYY-MM-DD format.")
    .optional(),
  recurrence: z
    .union([
      z.literal("daily"),
      z.literal("weekly"),
      z.literal("everyWeekday"),
      z.literal("monthly"),
      z.literal("yearly"),
      z.literal("custom"),
    ])
    .optional(),
  customPeriod: z
    .union([
      z.literal("day"),
      z.literal("week"),
      z.literal("month"),
      z.literal("year"),
    ])
    .optional(),
  customInterval: z.number().optional(),
  customWeekday: z.array(z.number()).optional(),
  paused: z.boolean().optional(),
});

export const adminPostSendNotificationsResDtoSchema = z.object({
  recipientsCount: z.number(),
});

export const adminNotificationRecipientResDtoSchema = z.object({
  customerId: z.string(),
  notificationId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  fullName: z.string(),
  locationId: z.string().optional(),
  address: z.string().optional(),
});

export const adminPostNotificationNotificationRecipientInitialListReqDtoSchema =
  z.object({
    recipientLists: z.array(
      z.union([
        z.literal("all"),
        z.literal("onDemand"),
        z.literal("annual"),
        z.literal("snowReporters"),
      ]),
    ),
  });

export const adminPostNotificationNotificationRecipientReqDtoSchema = z.object({
  customerId: z.string(),
  locationId: z.string().optional(),
});

export const adminPostNotificationNotificationRecipientReqDtoListSchema =
  z.object({
    recipients: z.array(adminPostNotificationNotificationRecipientReqDtoSchema),
  });

export const driverStatusDtoSchema = z.object({
  driverId: z.string(),
  status: z.union([z.literal("connected"), z.literal("disconnected")]),
  latitude: z.string(),
  longitude: z.string(),
  emmitTime: z.string(),
});

export const nameDtoSchema = z.object({
  name: z.string(),
});

export const locationDtoSchema = z.object({
  address: z.string(),
});

export const serviceAlertDtoSchema = z.object({
  id: z.string(),
  routeId: z.string(),
  locationId: z.string(),
  driverId: z.string(),
  title: z.string(),
  message: z.string(),
  status: z.union([z.literal("sent"), z.literal("notSentYet")]),
  sentAt: z.string().datetime().optional().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  driver: nameDtoSchema,
  customer: nameDtoSchema,
  location: locationDtoSchema,
});

export const patchServiceAlertReqDtoSchema = z.object({
  title: z.string().optional(),
  message: z.string().optional(),
});

export const eventNotificationsResDtoSchema = z.object({
  id: z.string(),
  event: z.union([
    z.literal("customerRouteDispatched"),
    z.literal("customerPlowCompleted"),
    z.literal("customerPlowPartiallyCompleted"),
    z.literal("customerPlowCouldNotCompleted"),
    z.literal("customerIncomingPlow"),
    z.literal("customerPlowDelayed"),
    z.literal("driverRouteDispatched"),
    z.literal("driverRouteStarted"),
    z.literal("driverRouteCompleted"),
    z.literal("driverRouteModifiedByAdmin"),
    z.literal("driverRouteAvailable"),
    z.literal("customerServiceModified"),
    z.literal("customerSkipOverriddenDispatched"),
  ]),
  accountType: z.union([
    z.literal("customer"),
    z.literal("admin"),
    z.literal("driver"),
    z.literal("super_admin"),
  ]),
  title: z.string(),
  description: z.string(),
  notificationDefaultMessage: z.string(),
  notificationCustomMessage: z.string(),
  notificationTitle: z.string(),
  updatedBy: adminAccountResDtoSchema.optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  notificationType: z.array(z.union([z.literal("push"), z.literal("email")])),
});

export const eventNotificationsUpdateReqDtoSchema = z.object({
  notificationTitle: z.string(),
  notificationCustomMessage: z.string(),
  notificationType: z
    .array(z.union([z.literal("push"), z.literal("email")]))
    .min(1),
});

export const adminCustomerLocationResDtoSchema = z.object({
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  fullName: z.string(),
  emailConfirmed: z.boolean(),
  locationId: z.string(),
  locationNoteCount: z.string(),
  customerId: z.string(),
  appAccess: z.boolean(),
  address: z.string(),
  serviceAccess: z.boolean(),
  street: z.string(),
  city: z.string(),
  zipCode: z.string(),
  state: z.string(),
  type: z.union([z.literal("onDemand"), z.literal("annual")]).optional(),
  reportsEnabled: z.boolean(),
  lastPlow: z.string().datetime().optional(),
  billingInformation: z.string(),
  notes: z.string(),
  serviceTime: z.number(),
  elevation: measurementResDtoSchema,
  region: adminRegionResDtoSchema,
});

export const adminCustomersLocationsPaginatedMetaDataDtoSchema = z.object({
  totalPages: z.number(),
  page: z.number(),
  limit: z.number(),
  count: z.number(),
  matchingLeadCount: z.number().optional(),
});

export const locationSchema = z.object({
  lat: z.number(),
  lng: z.number(),
});

export const plowInformationSchema = z.object({
  location: locationSchema,
  status: z.string(),
});

export const guestPlowStatusResDtoSchema = z.object({
  eta: z.string(),
  destination: locationSchema,
  plow: plowInformationSchema,
  readableStatus: z.string(),
  readableEta: z.string(),
});

export const paginatedResponseMetaDataDtoSchema = z.object({
  totalPages: z.number(),
  page: z.number(),
  limit: z.number(),
  count: z.number(),
});

export const paginatedResponseSchema = z.object({
  metaData: paginatedResponseMetaDataDtoSchema,
});
